import {ApplicationRef, Component, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {CadCartaocreditoComponent} from '../cad-cartaocredito/cad-cartaocredito.component';
import {ContratoService} from '../../superadmin/services/contrato.service';
import {EmpresasService} from '../../superadmin/services/empresas.service';

@Component({
  selector: 'app-cadastro-cartao-iugu',
  templateUrl: './cadastro-cartao-iugu.component.html',
  styleUrls: ['./cadastro-cartao-iugu.component.scss']
})
export class CadastroCartaoIuguComponent implements OnInit {
  @Input() contrato: any = {};
  @Input() tokenPublico: string;
  @Input() modal = false;
  @Output() onSalvou = new EventEmitter();
  @ViewChild('cccompoment', { static: false }) cccompoment: CadCartaocreditoComponent;

  erro: string;
  salvando = false;
  salvo = false;

  constructor(private contratoService: ContratoService,
              private empresasService: EmpresasService,
              private app: ApplicationRef) {
  }

  ngOnInit(): void {
  }

  salveCartao(cartao: any) {
    if(this.salvando) return;

    delete this.erro;
    this.salvando = true;

    const promise = this.tokenPublico ?
      this.empresasService.cadastreCartaoAssinaturaPublico(this.tokenPublico, cartao) :
      this.contratoService.cadastreCartaoAssinatura(this.contrato, cartao);

    promise.then((resposta: any) => {
      this.salvando = false;
      this.salvo = true;

      if(resposta?.assinatura)
        this.contrato.assinatura = resposta.assinatura;

      this.onSalvou.emit(resposta);
      this.app.tick();
    }).catch((erro: any) => {
      this.erro = erro;
      this.salvando = false;

      if(this.cccompoment)
        this.cccompoment.canceleProcessando();
    });
  }

  fecheMensagemErro() {
    delete this.erro;
  }
}
